let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jlw0L")).then(() => parcelRequire('5eNyq'));